
export default {}
export const API_URL = '/api'
export const API_TIMEOUT = 30 * 1000 // 30 seconds timeout

export const SITE_NAME = 'Agro'
export const IDENTITY_BACKEND = 'https://id.fernheim.com.py'
export const LOGIN_URL = IDENTITY_BACKEND + '/login'
export const LOGOUT_URL = IDENTITY_BACKEND + '/logout'
export const CONFIGURATION_URL = IDENTITY_BACKEND
export const SESSION_HISTORY_URL = IDENTITY_BACKEND + '/historial_sesiones'

export const COOKIE_NAME = 'id_sesion'
